var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"container"},'div',_vm.layoutProps,false),[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col col-md-6 col-xs-12"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }